<template>
  <el-row class="header" id="header">
    <div class="grid-content sidebar-upper" :class="{ topfloat: isActive }">
      <el-col :xs="19" :sm="19" :md="4" :lg="4" :xl="4" class="logo">
        <router-link tag="a" to="/">
          <img src="@/assets/images/lerdge-logo.png" />
        </router-link>
      </el-col>
      <el-col :sm="20" :md="18" :lg="18" :xl="18" class="nav">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
        >
          <template v-for="item in menuData">
            <el-menu-item
              :index="item.index"
              :key="item.index"
              v-if="item.child.length === 0"
            >
              <a :href="item.to" target="_blank">{{ item.label }}</a>
            </el-menu-item>
            <el-submenu
              :index="item.index"
              :key="item.index"
              :show-timeout="100"
              v-else
            >
              <template slot="title">{{ item.label }}</template>
              <template v-for="child in item.child">
                <el-menu-item
                  :index="child.index"
                  :key="child.index"
                  v-if="child.child.length === 0"
                >
                  <a :href="child.to" target="_blank">{{ child.label }}</a>
                </el-menu-item>
                <el-submenu
                  :index="child.index"
                  :key="child.index"
                  :show-timeout="100"
                  v-else
                >
                  <template slot="title">{{ child.label }}</template>
                  <!--third-->
                  <el-menu-item
                    v-for="grandson in child.child"
                    :index="grandson.index"
                    :key="grandson.index"
                    ><router-link tag="a" :to="grandson.to">
                      {{ grandson.label }}
                    </router-link>
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </el-col>
      <el-col :xs="3" :sm="3" :md="2" :lg="2" :xl="2" class="icon-nav">
        <router-link tag="a" to="/">
          <i class="iconfont icon-xuanzhongshangcheng"></i>
        </router-link>
        <a :href="toChangeLink" @click="toChange">
          <i class="iconfont icon-lang"></i>
        </a>
      </el-col>

      <!-- // media-nav -->
      <el-col :xs="2" :sm="2">
        <mediaNav :class="{ active: isActive }"></mediaNav>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import mediaNav from "./mediaNav";
export default {
  components: {
    mediaNav,
  },
  data() {
    return {
      isActive: false,
      menuData: [],
      active: true,
      toChangeLink: "",
    };
  },
  props: {
    activeIndex: {
      type: String,
    },
  },
  methods: {
    //中英文切换
    toChange() {
      if (this.$lang.current === "en") {
        this.toChangeLink = "//www.lerdge.cn";
      } else {
        this.toChangeLink = "//www.lerdge.com";
      }
    },
    async init() {
      this.menuData.push({
        label: this.$lang.com("home"),
        index: "0",
        to: "/",
        child: [],
      });
      // 后台分类
      let map = {
        machine: {
          path: "/machine",
        },
        product: {
          path: "/product",
        },
        model: {
          path: "/model",
        },
        about: {
          path: "/about",
        },
        community: {
          path: "",
        },
        config: {
          path: "",
        },
      };
      for (var item of this.$store.state.data.categories) {
        for (var key in map) {
          if (item.category_keywords === key) {
            let cur;
            // 主板放在product前面
            if (key === "product") {
              this.menuData.push({
                label: this.$lang.com("Board"),
                index: "10",
                to: "",
                child: [
                  {
                    label: this.$lang.com("Tutorial"),
                    index: "10-1",
                    to: "/document/Lerdge-Board",
                    child: [],
                  },
                  {
                    label: "Gcode",
                    index: "10-2",
                    to: "/document/detail/G0-G1",
                    child: [],
                  },
                  {
                    label: this.$lang.com("homeDownLoad"),
                    index: "10-3",
                    to: "/download/list/lerdge-k",
                    child: [],
                  },
                ],
              });
            }
            if (key === "product" && this.$lang.current === "en") {
              cur = {
                label: "Store",
                index: item.category_id.toString(),
                to: `https://shop.lerdge.com/`,
                child: [],
                isOutside: true,
              };
            } else if (key === "product" && this.$lang.current === "cn") {
              cur = {
                label: "商店",
                index: item.category_id.toString(),
                child: [
                  {
                    label: "淘宝",
                    index: "-1",
                    to: `https://lerdge.taobao.com/index.htm?spm=a1z10.3-c-s.w5002-23038214275.2.46d7c451eYuQFk`,
                    child: [],
                    isOutside: true,
                  },
                  {
                    label: "商城",
                    index: "-2",
                    to: `https://shop.lerdge.com/`,
                    child: [],
                    isOutside: true,
                  },
                ],
              };
            } else {
              let path = map[key].path;
              cur = {
                label: item.category_name,
                index: item.category_id.toString(),
                keywords: item.category_keywords,
                to: `${path === "" ? "" : path}/${item.category_keywords}`,
                child: [],
              };
              if (item.child.length > 0) {
                for (var child of item.child) {
                  cur.child.push({
                    label: child.category_name,
                    index: child.category_id.toString(),
                    keywords: child.category_keywords,
                    to: `${path}/${child.category_keywords}`,
                    child: [],
                  });
                }
              }
            }
            if (key === "community") {
              cur = {
                label: this.$lang.com("community"),
                index: "-1",
                to: "/community",
                child: [],
              };
            }
            this.menuData.push(cur);
            break;
          }
        }
      }
    },
    onScroll() {
      let scroll = document.documentElement.scrollTop;
      if (scroll >= 1) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
  created() {
    this.init();
    document.body.onscroll = this.onScroll;
  },
};
</script>
